<template>
  <div class="root">
    <!-- ヘッダー -->
    <Toolbar @changeView="changeView" @showDictionary="openDictionary" :viewName="viewName" :isMenuVisible="isMenuVisible" :platformName="platformName" :currentView="currentView" :isRegistered="isRegistered" />

    <!-- currentviewが変更されると、中身が変更する -->
    <component :is="currentView" @changeView="changeView" @setViewName="setViewName" @setMenuVisible="setMenuVisible" @showError="showError" @setIsRegistered="setIsRegistered" @showProcessing="(showed) => showProcessing = showed" :contentsDetail="contentsDetail" :platformName="platformName" ref="childComponent" 
      />

    <!-- エラーダイアログ -->
    <ErrorDialog v-if="showErrorDialog" @close="showErrorDialog = false" :message="errorMessage" :buttonKind="errorButtonKind" :platformName="platformName" />
    <!-- アップデート通知 -->
    <Notice v-if="showNotice" @close="showNotice = false" :platformName="platformName" />
    <!-- 辞書画面 -->
    <Dictionary v-if="showDictionary" @close="closeDictionary()" :platformName="platformName" :isModal="showDictionary"/>
    <!-- 進捗ダイアログ -->
    <Processing v-if="showProcessing" />
  </div><!-- root -->
</template>

<script>
import Toolbar from '@/components/Toolbar';
import None from '@/components/None';
import PurchasedList from '@/components/purchased/PurchasedList';
import PurchasedDetail from '@/components/purchased/PurchasedDetail';
import StoreList from '@/components/store/StoreList';
import StoreDetail from '@/components/store/StoreDetail';
import PortalList from '@/components/portal/PortalList';
import AuPortalList from '@/components/portal/AuPortalList';
import ErrorDialog from '@/components/Error';
import Login from '@/components/Login';
import Notice from '@/components/Notice';
import Dictionary from '@/components/dictionary/Dictionary';
import Processing from '@/components/Processing';
import common from '@/mixin/common';
import * as constants from '@/mixin/constants';

const VIEW_NAME_PORTALLIST = 'PortalList';
const VIEW_NAME_STORELIST = 'StoreList';
const VIEW_NAME_PURCHASEDLIST = 'PurchasedList';
const VIEW_NAME_AUPORTALLIST = 'AuPortalList';

export default {
  name: 'root',
  data: function () {
    return {
      currentView: 'None',
      contentsDetail: null,
      viewName: '',
      isMenuVisible: false,
      platformName: '',
      // エラー表示用
      showErrorDialog: false,
      errorMessage: '',
      errorButtonKind: '',
      isRegistered: false,
      // モバイルアプリアップデート通知表示
      showNotice: false,
      // 辞書画面表示
      showDictionary: false,
      // 進捗ダイアログ表示
      showProcessing: false
    }
  },
  components: {
    Toolbar,
    None,
    PurchasedList,
    PurchasedDetail,
    StoreList,
    StoreDetail,
    PortalList,
    AuPortalList,
    ErrorDialog,
    Login,
    Notice,
    Dictionary,
    Processing
  },
  mixins: [
    common,
  ],
  created: function () {
    this.log("Root start created");
    this.checkEnvironment();
    // モバイルアプリコールバック設定
    ROSETTA_onRestore = this.ROSETTA_onRestore;
    ROSETTA_onRegisterUser = this.ROSETTA_onRegisterUser;
    ROSETTA_onUnregisterUser = this.ROSETTA_onUnregisterUser;
  },
  mounted: function () {
    this.log("Root start mounted");
    var self = this;

    // モバイルアプリの場合、アプリバージョンを確認
    if(!this.isEnvironmentPc()) {
      this.checkMoblieUpdate();
    }

    // ローカルストレージ操作初期化処理
    storage_wrapper.initialize(this.$parent.iframeId, process.env.WEB_API_ORIGIN).then(function () {
      if (self.isDocomo(self.platformName)) {
        self.currentView = VIEW_NAME_PORTALLIST;
      } else if (self.isAu(self.platformName)) {
        self.currentView = VIEW_NAME_AUPORTALLIST;
      } else if (self.$route.query.Store == "true") {
        self.currentView = VIEW_NAME_STORELIST;
      } else {
        self.currentView = VIEW_NAME_PURCHASEDLIST;
      }
    }).catch(function (err) {
      self.log(err);
      if (self.isDocomo(self.platformName)) {
        self.currentView = VIEW_NAME_PORTALLIST;
      } else if (self.isAu(self.platformName)) {
        self.currentView = VIEW_NAME_AUPORTALLIST;
      } else {
        self.currentView = VIEW_NAME_PURCHASEDLIST;
      }
    });

    if(!this.isEnvironmentPc() && !this.isDocomo(this.platformName) && !this.isAu(this.platformName)) {
      if(this.$route.query.dictionary == "true") {
        this.openDictionary();
      }
    }
  },
  updated: function() {
    // 辞書画面表示中、背面をスクロール不可に設定
    if(this.showDictionary) {
      $(".page-content").css({
        "position" : "fixed",
      });
    }
  },
  methods: {
    /**
     * 表示中のコンポーネントを切り替える
     *
     * @param {String} nextView コンポーネント名
     * @param {Object} contentsDetail コンテンツ情報(未指定可)
     */
    changeView: function (nextView, contentsDetail) {
      this.log("changeView: " + nextView);
      this.contentsDetail = contentsDetail;
      this.currentView = nextView;
    },
    /**
     * ヘッダ部に表示する画面名称を設定する
     *
     * @param {String} viewName 名称
     */
    setViewName: function (viewName) {
      this.viewName = viewName;
    },
    /**
     * メニュー表示有無を設定する
     *
     * @param {Boolean} isVisible true:表示する、false:表示しない
     */
    setMenuVisible: function (isVisible) {
      this.isMenuVisible = isVisible;
    },
    /**
     * エラーダイアログを表示する
     *
     * @param {String} message 表示するメッセージ
     * @param {String} buttonKind ボタンの種類
     */
    showError: function (message, buttonKind) {
      this.errorMessage = message;
      this.errorButtonKind = buttonKind;
      this.showErrorDialog = true;
    },
    /**
     * 実行環境を確認
     */
    checkEnvironment: function () {
      // 実行環境の確認
      if (window.hasOwnProperty(constants.MOBILE_INTERFACE_NAME)) {
        // モバイルアプリの場合はプラットフォーム名を確認
        if (window.Phone.GetPlatformName() == constants.PLATFORM_ANDROID) {
          // androidの場合はパッケージ名を確認
          if (window.Phone.GetPackageName().startsWith(constants.PACKAGE_DOCOMO_ANDROID)) {
            this.platformName = constants.PLATFORM_DOCOMO;
          } else if(window.Phone.GetPackageName().startsWith(constants.PACKAGE_AU_ANDROID)) {
            this.platformName = constants.PLATFORM_AU;
          } else if(window.Phone.GetPackageName().startsWith(constants.PACKAGE_SOFTBANK_ANDROID)) {
            this.platformName = constants.PLATFORM_SOFTBANK;
          } else if(window.Phone.GetPackageName().startsWith(constants.PACKAGE_LIBRARY_ANDROID)) {
            this.platformName = constants.PLATFORM_LIBRARY;
          } else if(window.Phone.GetPackageName().startsWith(constants.PACKAGE_AU_ANDROID)) {
            this.platformName = constants.PLATFORM_AU;
          }
        } else if(window.Phone.GetPlatformName() == constants.PLATFORM_IOS) {
          this.platformName = constants.PLATFORM_IOS;
        }
      }
    },
    /**
     * ユーザ登録連携／連携解除表示を設定する
     *
     * @param {Boolean} isRegistered 登録済みか否か true:登録済み, false:未登録
     */
    setIsRegistered: function(isRegistered) {
      this.isRegistered = isRegistered;
    },
    /**
     * モバイルアプリコールバック：復元処理完了
     */
    ROSETTA_onRestore: function () {
      // 購入済みコンテンツ一覧画面の表示
      this.changePuchasedList()
    },
    /**
     * モバイルアプリコールバック：ユーザ登録処理完了
     */
    ROSETTA_onRegisterUser: function () {
      // 購入済みコンテンツ一覧画面の表示
      this.changePuchasedList()
    },
    /**
     * モバイルアプリコールバック：ユーザ登録解除処理完了
     */
    ROSETTA_onUnregisterUser: function () {
      // 購入済みコンテンツ一覧画面の表示
      this.changePuchasedList()
    },
    /**
     * 購入済みコンテンツ一覧画面を表示し、コンテンツを更新する
     */
    changePuchasedList: function() {
      this.changeView('PurchasedList');
      this.$refs.childComponent.setContents();
    },
    /**
     * 辞書画面の表示
     */
    openDictionary: function() {
      try {
        window.Phone.ShowDictionary("");
      }
      catch (err) {
        this.log("openDictionary Error:" + err)
        this.showDictionary = true;
      }
    },
    /**
     * 辞書画面を閉じる
     */
    closeDictionary: function() {
      $(".page-content").removeAttr("style");
      this.showDictionary = false;
    },
    /**
     * モバイルアプリのバージョン確認
     */
    checkMoblieUpdate: function() {
      try {
        var version = window.Phone.GetVersionCode();
        if(this.isLibraryAndroid(this.platformName)) {
          // ライブラリ版androidアプリのバージョンを確認
          if(Number(version) < constants.VERSION_LIBRARY_ANDROID) {
            // アップデート通知
            this.showNotice = true;
          }
        } else if(this.isDocomo(this.platformName)) {
          // ドコモBasic版アプリのバージョンを確認
          if(Number(version) < constants.VERSION_DOCOMO_ANDROID) {
            // アップデート通知
            this.showNotice = true;
          }
        } else if(this.isAu(this.platformName)) {
          // au版アプリのバージョンを確認
          if(Number(version) < constants.VERSION_AU_ANDROID) {
            // アップデート通知
            this.showNotice = true;
          }
        } else if(this.isPlatformiOS(this.platformName)) {
          // iOSアプリのバージョンを確認
          var split = version.split(".");
          if(Number(split[0]) == constants.VERSION_LIBRARY_IOS_MAJOR) {
            if(Number(split[1]) == constants.VERSION_LIBRARY_IOS_MINOR) {
              if(Number(split[2]) < constants.VERSION_LIBRARY_IOS_REV) {
                // アップデート通知
                this.showNotice = true;
              }
            } else if(Number(split[1]) < constants.VERSION_LIBRARY_IOS_MINOR) {
              // アップデート通知
              this.showNotice = true;
            }
          } else if(Number(split[0]) < constants.VERSION_LIBRARY_IOS_MAJOR) {
            // アップデート通知
            this.showNotice = true;
          }
        }
      } catch(e) {
        this.log("GetVersionCode exception: " + e.message);
        // アップデート通知
        this.showNotice = true;
      }
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// Root.vue?0c4b94aa